import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _EnumerationParameter;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { makeObservable, observable, override, reaction } from "mobx";
import isDefined from "../../Core/isDefined";
import CommonStrata from "../Definition/CommonStrata";
import FunctionParameter from "./FunctionParameter";
let EnumerationParameter = (_class = (_EnumerationParameter = class EnumerationParameter extends FunctionParameter {
  constructor(catalogFunction, options) {
    super(catalogFunction, options);
    _defineProperty(this, "type", "enumeration");
    _initializerDefineProperty(this, "options", _descriptor, this);
    makeObservable(this);
    this.options = options.options;

    // Set value to something useful if undefined (and a value isRequired)
    reaction(() => this.value, () => {
      var _this$options;
      if (!isDefined(this.value) && this.isRequired && (_this$options = this.options) !== null && _this$options !== void 0 && (_this$options = _this$options[0]) !== null && _this$options !== void 0 && _this$options.id) {
        this.setValue(CommonStrata.user, this.options[0].id);
      }
    }, {
      fireImmediately: true
    });
  }
  get isValid() {
    if (!isDefined(this.value)) {
      return !this.isRequired;
    }
    return isDefined(this.options.find(option => option.id === this.value));
  }
}, _defineProperty(_EnumerationParameter, "type", "enumeration"), _EnumerationParameter), _descriptor = _applyDecoratedDescriptor(_class.prototype, "options", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [override], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _class);
export { EnumerationParameter as default };